'use client';

import { reprojectArticle } from '@components/PreCartInternalTools/ArticleTools/reprojectArticle';
import { Box, freddyTheme, Link } from '@coolblue-development/freddy';
import { Checkmark, Copy, Refresh } from '@coolblue-development/icons';
import { ArticlePanelContext } from '@coolblue-development/next-hemingway/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useContext, useState } from 'react';

export function CopyLinkIcon({ text }: { text: string | undefined }) {
  const [linkIsCopied, setLinkIsCopied] = useState(false);
  const copyId = (id: string) => {
    navigator.clipboard.writeText(id);
    setLinkIsCopied(true);

    setTimeout(() => {
      setLinkIsCopied(false);
    }, 2000);
  };

  return (
    text && (
      <Box title='Copy s'>
        {linkIsCopied ? (
          <Checkmark fill={freddyTheme.color.icon.sentimentPositive} size='small' />
        ) : (
          <Copy
            onClick={() => copyId(text)}
            fill={freddyTheme.color.icon.subtle}
            size='small'
            style={{
              cursor: 'pointer',
              verticalAlign: 'baseline'
            }}
          />
        )}
      </Box>
    )
  );
}

export function ReprojectArticleIcon({ articleId }: { articleId: string }) {
  const { environment } = useRequestContext();
  const [isReprojecting, setIsReprojecting] = useState(false);

  return (
    <Box title='Reproject article'>
      <Refresh
        aria-label='reproject article'
        size='small'
        onClick={() => {
          setIsReprojecting(true);
          reprojectArticle(articleId, environment).then(() => {
            setIsReprojecting(false);
          });
        }}
        style={{
          cursor: 'pointer',
          verticalAlign: 'baseline',
          transform: isReprojecting ? 'rotate(360deg)' : 'rotate(0deg)',
          transition: 'transform 1s ease-in-out',
          fill: isReprojecting ? freddyTheme.color.icon.base : freddyTheme.color.icon.subtle
        }}
      />
    </Box>
  );
}

export function ArticleInPanelLink({ nodeId }: { nodeId: string }) {
  const { setPanelNodeId } = useContext(ArticlePanelContext);

  return (
    <Link
      onClick={() => {
        if (!setPanelNodeId) return;

        setPanelNodeId(nodeId);
      }}
    >
      Open article in panel
    </Link>
  );
}
